<template>
    <div class="loader folders-loading">
        <div class="list-info"><span>{{Language.say(props.text)}}</span></div>

        <div class="folders-list search-list">
            <div class="folder-item" v-for="n in lines" :key="'f_l_' + n">
                <div class="checkbox">
                    <input type="checkbox">
                    <label></label>
                </div>
                <div class="folder">
                    <span class="menu-icon">
                        <i class="far fa-folder"></i>
                    </span>
                    <span class="menu-title">
                        <small></small>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
  import { defineProps } from 'vue';
  import Language        from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    text : {
      default: 'folders.loading',
    },

    lines : {
      default: 10
    }
  })
</script>
